<template>
  <div v-if="isUnfold" @mouseleave="currentCode =''">
    <!-- 第一排 -->
    <div class="tab-guide-wrapper">
      <div
        v-for="(item) in firstRowData"
        :key="item.code"
        class="tab-guide"
        @mouseenter="showSubNodes(item.code)"
      >
        <div class="tab-guide-column">
          <div class="tab-guide-row">
            <div class="tab-guide-item" :class="{disabled: item.disabled}">
              <svg-icon v-if="activeName === 'SI' || activeName === 'SE'" icon-class="sop-sea" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else-if="activeName === 'AI' || activeName === 'AE'" icon-class="sop-air" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else icon-class="sop-land" class="svg-common" style="margin-right: 0px;" />
            </div>
            <i v-if="item.error" class="el-icon-warning" />
            <ul v-if="currentCode === item.code && !item.disabled" class="sub-node">
              <li
                v-for="(subItem) in item.subNodes"
                :key="subItem.subCode"
                @click="jumpSopNodeDetail"
              ><span>{{ subItem.subName }}:</span><span>{{ subItem.count }}</span></li>
            </ul>
            <div class="tab-guide-arrow" />
          </div>
          <div class="tab-guide-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div v-show="secondRowData.length>0" class="tab-two">
      <div class="tab-guide-arrow tab-guide-arrow_right" />
    </div>
    <!-- 第二排 -->
    <div class="tab-guide-wrapper tab_threeRowData" :class="{flexend: threeRowData.length === 0}">
      <div
        v-for="(item,index) in secondRowData"
        :key="index"
        class="tab-guide"
        @mouseenter="showSubNodes(item.code)"
      >
        <div class="tab-guide-column">
          <div class="tab-guide-row">
            <div class="tab-guide-item" :class="{disabled: item.disabled}">
              <svg-icon v-if="activeName === 'SI' || activeName === 'SE'" icon-class="sop-sea" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else-if="activeName === 'AI' || activeName === 'AE'" icon-class="sop-air" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else icon-class="sop-land" class="svg-common" style="margin-right: 0px;" />
            </div>
            <i v-if="item.error" class="el-icon-warning" />
            <ul v-if="currentCode === item.code && !item.disabled" class="sub-node">
              <li
                v-for="(subItem) in item.subNodes"
                :key="subItem.subCode"
              ><span>{{ subItem.subName }}:</span><span>{{ subItem.count }}</span></li>
            </ul>
            <div class="tab-guide-arrow" />
          </div>
          <div class="tab-guide-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div v-show="threeRowData.length>0" class="tab_three">
      <div class="tab-guide-arrow" />
    </div>
    <!-- 第三排 -->
    <div class="tab-guide-wrapper tab_four">
      <div
        v-for="(item,index) in threeRowData"
        :key="index"
        class="tab-guide"
        @mouseenter="showSubNodes(item.code)"
      >
        <div class="tab-guide-column">
          <div class="tab-guide-row">
            <div class="tab-guide-item" :class="{disabled: item.disabled}">
              <svg-icon v-if="activeName === 'SI' || activeName === 'SE'" icon-class="sop-sea" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else-if="activeName === 'AI' || activeName === 'AE'" icon-class="sop-air" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else icon-class="sop-land" class="svg-common" style="margin-right: 0px;" />
            </div>
            <i v-if="item.error" class="el-icon-warning" />
            <ul v-if="currentCode === item.code && !item.disabled" class="sub-node">
              <li
                v-for="(subItem) in item.subNodes"
                :key="subItem.subCode"
              ><span>{{ subItem.subName }}:</span><span>{{ subItem.count }}</span></li>
            </ul>
            <div class="tab-guide-arrow" />
          </div>
          <div class="tab-guide-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div v-show="fourRowData.length>0" class="tab-two">
      <div class="tab-guide-arrow tab-guide-arrow_right" />
    </div>
    <!-- 第四排 -->
    <div class="tab-guide-wrapper tab_threeRowData" :class="{flexend: fiveRowData.length === 0}">
      <div
        v-for="(item,index) in fourRowData"
        :key="index"
        class="tab-guide"
        @mouseenter="showSubNodes(item.code)"
      >
        <div class="tab-guide-column">
          <div class="tab-guide-row">
            <div class="tab-guide-item" :class="{disabled: item.disabled}">
              <svg-icon v-if="activeName === 'SI' || activeName === 'SE'" icon-class="sop-sea" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else-if="activeName === 'AI' || activeName === 'AE'" icon-class="sop-air" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else icon-class="sop-land" class="svg-common" style="margin-right: 0px;" />
            </div>
            <i v-if="item.error" class="el-icon-warning" />
            <ul v-if="currentCode === item.code && !item.disabled" class="sub-node">
              <li
                v-for="(subItem) in item.subNodes"
                :key="subItem.subCode"
              ><span>{{ subItem.subName }}:</span><span>{{ subItem.count }}</span></li>
            </ul>
            <div class="tab-guide-arrow" />
          </div>
          <div class="tab-guide-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div v-show="fiveRowData.length>0" class="tab_three">
      <div class="tab-guide-arrow" />
    </div>
    <!-- 第五排 -->
    <div class="tab-guide-wrapper tab_four">
      <div
        v-for="(item,index) in fiveRowData"
        :key="index"
        class="tab-guide"
        @mouseenter="showSubNodes(item.code)"
      >
        <div class="tab-guide-column">
          <div class="tab-guide-row">
            <div class="tab-guide-item" :class="{disabled: item.disabled}">
              <svg-icon v-if="activeName === 'SI' || activeName === 'SE'" icon-class="sop-sea" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else-if="activeName === 'AI' || activeName === 'AE'" icon-class="sop-air" class="svg-common" style="margin-right: 0px;" />
              <svg-icon v-else icon-class="sop-land" class="svg-common" style="margin-right: 0px;" />
            </div>
            <i v-if="item.error" class="el-icon-warning" />
            <ul v-if="currentCode === item.code && !item.disabled" class="sub-node">
              <li
                v-for="(subItem) in item.subNodes"
                :key="subItem.subCode"
              ><span>{{ subItem.subName }}:</span><span>{{ subItem.count }}</span></li>
            </ul>
            <div class="tab-guide-arrow" />
          </div>
          <div class="tab-guide-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div v-show="sixRowData.length>0" class="tab-two">
      <div class="tab-guide-arrow tab-guide-arrow_right" />
    </div>
    <!-- 第六排 -->
    <div class="tab-guide-wrapper tab_threeRowData flexend">
      <div
        v-for="(item,index) in sixRowData"
        :key="index"
        class="tab-guide"
        @mouseenter="showSubNodes(item.code)"
      >
        <div class="tab-guide-column">
          <div class="tab-guide-row">
            <div class="tab-guide-item" :class="{disabled: item.disabled}">
              <i class="el-icon-error" />
            </div>
            <i v-if="item.error" class="el-icon-warning" />
            <ul v-if="currentCode === item.code && !item.disabled" class="sub-node">
              <li
                v-for="(subItem) in item.subNodes"
                :key="subItem.subCode"
              ><span>{{ subItem.subName }}:</span><span>{{ subItem.count }}</span></li>
            </ul>
            <div class="tab-guide-arrow" />
          </div>
          <div class="tab-guide-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

</style>
